const ProfileData = () => {
  return <div className="profile-container"></div>;
};

export default ProfileData;
